<!--
@create date 2024-4-15
@desc M832.phomemo.com
-->
<template>
  <div class="guides-main-container">
    <div class="guides-div-m834">
      <div class="topText">
        <h1>Download for Phomemo M834 Portable Printer</h1>
      </div>
      <div class="contactWrapper">
        <h1>Contact Us</h1>
        <div class="everyRow">
          <svg
            t="1711532586488"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="4745"
            width="36"
            height="36"
          >
            <path
              d="M926.47619 355.644952V780.190476a73.142857 73.142857 0 0 1-73.142857 73.142857H170.666667a73.142857 73.142857 0 0 1-73.142857-73.142857V355.644952l304.103619 257.828572a170.666667 170.666667 0 0 0 220.745142 0L926.47619 355.644952zM853.333333 170.666667a74.044952 74.044952 0 0 1 26.087619 4.778666 72.704 72.704 0 0 1 30.622477 22.186667 73.508571 73.508571 0 0 1 10.678857 17.67619c3.169524 7.509333 5.12 15.652571 5.607619 24.210286L926.47619 243.809524v24.380952L559.469714 581.241905a73.142857 73.142857 0 0 1-91.306666 2.901333l-3.632762-2.925714L97.52381 268.190476v-24.380952a72.899048 72.899048 0 0 1 40.155428-65.292191A72.97219 72.97219 0 0 1 170.666667 170.666667h682.666666z"
              p-id="4746"
              fill="#e53f3f"
            ></path>
          </svg>
          Email：<a
            href="mailto:support@phomemo.com"
            @click="
              () => {
                refreshRecord({ key: 'M832_email' });
              }
            "
            >support@phomemo.com</a
          >
        </div>
        <div class="everyRow">
          <svg
            t="1711532541066"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="3541"
            width="36"
            height="36"
          >
            <path
              d="M398.652952 165.692952c-32.280381-46.006857-58.172952-61.318095-92.867047-54.808381-14.969905 2.80381-24.210286 7.850667-41.20381 22.528l-12.946285 11.361524-25.185524 20.894476-6.582857 5.753905c-3.705905 3.413333-6.38781 6.217143-9.825524 10.118095-64 72.46019-81.724952 185.782857-44.470857 292.327619 26.794667 76.55619 74.605714 152.624762 142.774857 228.644572 72.289524 80.62781 133.046857 131.364571 202.922666 168.374857 54.857143 29.013333 96.865524 41.74019 145.676191 43.227429 59.001905 1.828571 110.957714-11.50781 153.648762-39.15581a162.133333 162.133333 0 0 0 19.553524-15.189333l8.289523-7.558095 16.335239-15.213715 5.534476-4.924952 10.922666-9.435429c22.040381-19.651048 29.184-31.939048 30.646858-51.370666 2.194286-29.647238-11.215238-52.736-49.737143-85.699048l-26.063238-21.820952-12.117334-10.581334-11.459047-9.825524c-37.229714-30.744381-64.804571-40.69181-100.205715-35.35238-24.283429 3.632762-38.278095 12.141714-63.073523 38.107428l-10.947048 11.654095c-18.041905 19.017143-28.330667 26.258286-43.544381 29.305905-22.25981 4.461714-44.373333-7.046095-80.262095-36.205714-46.250667-37.546667-84.626286-80.676571-117.613715-131.949714-22.869333-35.766857-31.890286-62.902857-24.941714-87.600762 2.82819-9.99619 9.679238-17.042286 24.064-28.184381l14.994286-11.312762 2.413714-1.877334 22.747429-18.553904c20.114286-16.822857 28.281905-28.281905 32.572952-45.836191 8.899048-36.10819 0.487619-66.072381-32.426667-117.638095l-15.62819-24.234667-5.558857-8.533333-6.436572-9.435429z"
              p-id="3542"
              fill="#e53f3f"
            ></path>
          </svg>
          Tel：+1 855 957 5321(US ONLY)
        </div>
        <div class="everyRow">Whatsapp：+44 7355 725440</div>
      </div>

      <div class="contactWrapper">
        <h1 style="margin-bottom: 50px">Quick Start Guide</h1>
        <div
          v-for="(item, index) in m834Info.guidesList"
          :key="index"
          class="downloadBtnNewest"
          title="Click to view"
          @click="
            () => {
              refreshRecord({ key: 'M832_quickStartGuide' });
              window.open(item.url);
            }
          "
        >
          <img :src="item.iconUrl" />
          {{ item.title }}
        </div>
      </div>

      <div class="filter_warpper">
        <h1 style="margin-bottom: 50px">Drivers</h1>
        <div class="filter_warpper_tab">
          <div
            class="filter_tab"
            @click="filterContent(1)"
            :class="{ active: driverContentType === 1 }"
          >
            Windows
          </div>
          <div
            class="filter_tab"
            @click="filterContent(2)"
            :class="{ active: driverContentType === 2 }"
          >
            Mac OS
          </div>
          <div
            class="filter_tab"
            @click="filterContent(3)"
            :class="{ active: driverContentType === 3 }"
          >
            Chrome OS
          </div>
          <div
            class="filter_tab fqaItem_tab"
            @click="filterContent(4)"
            :class="{ active: driverContentType === 4 }"
            style="width: 88px"
          >
            Linux
          </div>
          <div
            class="filter_tab fqaItem_tab"
            @click="filterContent(5)"
            :class="{ active: driverContentType === 5 }"
            style="width: 105px"
          >
            App
          </div>
        </div>

        <div class="filter_warpper_content">
          <div
            class="videoWarpper"
            v-show="driverContentType === item.key"
            v-for="item in m834Info.driverList"
            :key="item.key"
          >
            <div class="videoContainer">
              <video
                controls
                webkit-playsinline="true"
                class="video"
                :poster="item.poster"
              >
                <source
                  :src="item.videoUrl"
                  type="video/mp4"
                />
                您的浏览器不支持 HTML5 video 标签。
              </video>
            </div>

            <div class="downloadContentWrapper">
              <div class="downloadTitleBar">
                <span>{{ item.title }}</span>
                <div class="downloadText">
                  <p>
                    {{ item.desp }}
                  </p>
                  <p class="versionText">
                    {{ item.version }}
                  </p>
                </div>
                <div
                  class="downloadBtnNew"
                  title="Click to download"
                  @click="
                    () => {
                      if (item.recordKey)
                        refreshRecord({
                          key: item.recordKey,
                        });
                      window.open(item.url);
                    }
                  "
                >
                  {{ item.btnText || "DOWNLOAD" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="faqsDivWrapper">
        <h1 style="margin-bottom: 50px">FAQ</h1>
        <div class="faq-container">
          <div
            class="faq-item"
            v-for="(item, index) in m834Info.faqData"
            :key="index"
          >
            <div class="faq-title" @click="clickQuestion(item, index)">
              <span v-text="item.title"></span>
              <img
                src="https://doc.labelife.net/upload/documents/tattoo/delIconImg.png"
                class="downArrow"
                v-show="activeQuestion.index === index"
              />
              <img
                src="https://doc.labelife.net/upload/documents/tattoo/addIconImg.png"
                class="downArrow"
                v-show="activeQuestion.index !== index"
              />
            </div>
            <div class="faq-scroll-area">
              <div
                class="faq-content"
                v-show="activeQuestion.index === index"
                v-for="(child, y) in item.details"
                :key="index + '-' + y"
              >
                <div class="content-title" v-html="child.theme"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="alsoLikeWrapper">
        <h1>You May Also Like</h1>
        <h4>Combine your style with these products</h4>
        <div class="itemsWrapper">
          <div
            class="img-item"
            v-for="(item, index) in m834Info.alsoLikeArr"
            :key="index"
          >
            <div class="imgInner">
              <div
                class="imgBox"
                :style="{
                  paddingTop: item.isLowerImg ? '40px' : '',
                  paddingLeft: item.isLowerImg ? '6px' : '',
                  paddingRight: item.isLowerImg ? '6px' : '',
                  background: item.isLowerImg ? '#fff' : '',
                }"
              >
                <img
                  :src="item.img"
                  title="Click to learn more"
                  @click="
                    () => {
                      window.open(item.productUrl);
                    }
                  "
                />
              </div>
              <p>
                {{ item.title }}
              </p>
              <div style="padding: 0 6px">
                <div
                  class="downloadBtnNewestEx"
                  title="Click to view"
                  @click="
                    () => {
                      window.open(item.productUrl);
                    }
                  "
                >
                  View More
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { m834Info } from "./dataConfig.js";
import { refreshRecord, sensorsRecord } from "@/util.js";
import { isMobile } from "@/util.js";
import Swipe from "vant/lib/swipe";
import "vant/lib/swipe/style";
import SwipeItem from "vant/lib/swipe-item";
import "vant/lib/swipe-item/style";

export default {
  name: "M834_new",
  components: {
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
  },
  data() {
    return {
      window,
      isMobile,
      refreshRecord,
      sensorsRecord,
      m834Info,

      driverContentType: 1,

      clickItem: { index: 0 },
      showVideo: true,
      activeQuestion: {},
    };
  },
  mounted() {
    sensorsRecord({ key: "M832_view" }, 1);
    sensorsRecord({ key: "M832_WebStay" }, 3);
    //页面停留上报时设置自定义参数
  },
  methods: {
    filterContent(value) {
      this.driverContentType = value;
    },
    handleClickItem(item = {}, index) {
      this.clickItem = { ...item, index };
      this.showVideo = !this.showVideo;
      if (item.recordKey) {
        refreshRecord({ key: item.recordKey });
      }
    },
    clickQuestion(item = {}, index) {
      const { activeQuestion } = this;
      if (
        activeQuestion.index === undefined ||
        activeQuestion.index !== index
      ) {
        this.activeQuestion = { ...item, index };
        refreshRecord({ key: "M08F_FAQ" + (index + 1) });
      } else this.activeQuestion = {};
    },
  },
};
</script>

<style lang="less" src="./M834_new.less" />



// WEBPACK FOOTER //
// src/view/guides/M834_new.vue